import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ValidationErrors, ControlContainer, FormGroupDirective, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Location } from '@angular/common'

import { merge, fromEvent, Observable, forkJoin, from } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, tap, delay, switchMap } from 'rxjs/operators';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GeneralLedgerService  } from '../../services/general-ledger.service';
import { GlobalsService } from '../../services/globals.service';
import { PrintService } from '../../services/print.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

declare let $: any;

@Component({
	selector: 'app-journal-entry',
	templateUrl: './journal-entry.component.html',
	styleUrls: ['./journal-entry.component.scss']
})
export class JournalEntryComponent implements OnInit {

	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild('locationsearch') customersearch: ElementRef;
	@ViewChild('editAddAccount') editAddRef: ElementRef;
	@ViewChild('print_table') printtable: ElementRef;
	loccode: any = '';
	addedgl: any = false;
	locselected = false;
	sending = false;
	ld: any = [];
	term: any = '';

	taxgroup: any = '';
	taxes: any = [];
	currencies: any = [];
	bankaccounts: any = [];
	types: any = [];
	zones: any = [];
	accountForm: any = false;
	groups: any = [];
	pandl: any = [];
	accounts: any = [];
	results: any = [];
	glaccounts: any = [];
	allglaccounts: any = [];
	color = 'blue'
	filteredOptions: Observable<any[]>;
	debits_credits: any = [];
	now = new Date();
	resetjournal = false;
	tags: any[] = [];
	editingIndex: number | null = null;
	preselectedAccount: any = null;
	journal_types = [
		'normal', 'reversing'
	];
	reversalJournalNumber: string | null = null;
	expenseSectionId: string | null = null;

	glUploadFiles: File[] = [];
	glUploadedHeaders: string[] = [];
	glUploadedRawData: any[] = [];
	glColumnMappings: { [header: string]: string } = {};
	glUploadReady = false;
	glUploadPanelExpanded = false;
	glDropzoneActive = false;
	glPosting = false;
	glError = '';
	glAvailableFieldTypes: string[] = ['trandate', 'account', 'description', 'debitcredit', 'department', 'ignore'];

	attachmentFiles: File[] = [];

	constructor(private route: ActivatedRoute, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, private fb: UntypedFormBuilder, public globalsService: GlobalsService, private modalService: NgbModal, public generalLedgerService: GeneralLedgerService, public printService: PrintService) {

		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.resetjournal = false;
		this.setForm();
		const navigation = this.router.getCurrentNavigation();
		const navState = (navigation?.extras?.state || history.state) as { reversalLines?: any[]; reversalJournalNumber?: string } | undefined;
		forkJoin([
			this.globalsService.getGLAccounts(),
			this.generalLedgerService.getTags(),
			this.globalsService.getAccountSections()
		]).subscribe(([accounts, tagsResponse, sections]: [any, any, any]) => {
			this.glaccounts = accounts;
			this.allglaccounts = accounts;
			this.filteredOptions = accounts as any;
			this.tags = (tagsResponse && tagsResponse.tags) ? tagsResponse.tags : [];
			const sectionList = Array.isArray(sections) ? sections : (sections?.rows || []);
			const expenseSection = sectionList.find((s: any) => (s.sectionname || s.sectionName || '') === 'Expense');
			this.expenseSectionId = expenseSection ? (expenseSection.sectionid || expenseSection.sectionId || null) : null;
			this.globalsService.getCurrencies().subscribe((results: any) => {
				this.currencies = results;
			});
			if (navState?.reversalLines?.length) {
				this.debits_credits = this.normalizeReversalLines(navState.reversalLines, accounts);
				this.accountForm.get('trandate').setValue(this.now.toISOString());
				this.reversalJournalNumber = navState.reversalJournalNumber ?? null;
				this.cdr.detectChanges();
			}
		});
	}

	private normalizeReversalLines(lines: any[], accounts: any[]): any[] {
		return lines.map((line: any) => {
			const accountCode = line?.account?.accountcode || line?.account?.accountCode || line?.accountCode;
			const matchedAccount = accounts.find((acc: any) => acc.accountcode === accountCode);

			return {
				...line,
				account: matchedAccount || line.account
			};
		});
	}

	private getLineTagId(line: any): string {
		const d = line?.department;
		if (d == null) { return ''; }
		if (d && (d.tagId !== undefined || d.tagref !== undefined)) { return String(d.tagId ?? d.tagref ?? ''); }
		return typeof d === 'string' ? d : '';
	}

	private hasExpenseAccount(lines: any[], expenseSectionId: string | null): boolean {
		if (!expenseSectionId || !lines?.length) { return false; }
		const sectionId = String(expenseSectionId);
		return lines.some((line: any) => {
			const acc = line?.account;
			if (!acc) { return false; }
			const sid = acc.sectioninaccounts != null ? String(acc.sectioninaccounts) : null;
			return sid === sectionId;
		});
	}


	addGl(event: any) {
		const selection = event?.option?.value ?? event;
		this.accountForm.get('account').setValue(selection);
		this.updateDepartmentRequiredState(selection);
	}

	private updateDepartmentRequiredState(account: any) {
		const deptControl = this.accountForm?.get('department');
		if (!deptControl) { return; }
		const isExpense = account && this.expenseSectionId != null &&
			String(account.sectioninaccounts) === String(this.expenseSectionId);
		if (isExpense) {
			deptControl.setValidators([Validators.required]);
		} else {
			deptControl.clearValidators();
		}
		deptControl.updateValueAndValidity();
		this.cdr.detectChanges();
	}

	isDepartmentRequired(): boolean {
		const account = this.accountForm?.get('account')?.value;
		return !!(account && this.expenseSectionId != null &&
			String(account.sectioninaccounts) === String(this.expenseSectionId));
	}


	setForm() {


		this.accountForm = this.fb.group({
			trandate: [ this.now.toISOString(), [Validators.required]],
			type: ['normal',[Validators.required]],
			account: ['', [Validators.required]],
			description: ['', [Validators.required]],
			debitcredit: [0, [Validators.required]],
			entryType: ['debit', [Validators.required]],
			department: [null],
		});
	}

	loadData() {
		this.globalsService.getGLAccounts().subscribe((results: any) => {
			this.glaccounts = results;
			this.allglaccounts = results;
			this.filteredOptions = results;
		});
		this.globalsService.getCurrencies().subscribe((results: any) => {
			this.currencies = results;
		});
		this.generalLedgerService.getTags().subscribe((r: any) => {
			this.tags = r.tags || [];
		});
	}

	getFormValidationErrors() {
		Object.keys(this.accountForm.controls).forEach((key, index) => {
			const controlErrors: ValidationErrors = this.accountForm.get(key).errors;
			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					//this.customerForm.controls[index].markAsTouched()
					this.accountForm.markAllAsTouched();
					this.accountForm.markAsUntouched()

					if (key == 'reference') {
						key = 'PO Number';
					}

					this.globalSearchService.showNotification(key + ' ' + keyError, 'danger', 'bottom', 'right')
				});
			}
		});
	}

	getCreditTotal() : number {
		let value = 0.00;
		if(this.debits_credits.length) {
			value = this.debits_credits.reduce(function(accumulator: number, items: any) {
				if(parseFloat(items.debitcredit) < 0) {
					 accumulator = accumulator + Math.abs(parseFloat(items.debitcredit));
				}
				return accumulator
			}, 0) ;
		}
		return value;
	}

	getDebitTotal() : number {
		let value = 0.00;
		if(this.debits_credits.length) {
			value = this.debits_credits.reduce(function(accumulator: number, items: any) {
				if(parseFloat(items.debitcredit) >= 0) {
					 accumulator = accumulator + parseFloat(items.debitcredit);
				}
				return accumulator
			}, 0) ;
		}
		return value;

	}

	requiredToBalance(): number {
		let value = 0.00;
		if(this.debits_credits.length) {
			value = this.debits_credits.reduce(function(accumulator: number, items: any) {
				return accumulator + parseFloat(items.debitcredit);
			}, 0) ;
		}
		return value;
	}

	isBalanced(): boolean {
		return Math.abs(this.requiredToBalance()) < 0.005;
	}

	addValue() {
		if(this.accountForm.valid) {
			const amount = parseFloat(this.accountForm.get('debitcredit').value);
			if(!amount && this.editingIndex === null) { return; }
			const entryType = this.accountForm.get('entryType').value;
			const entryData = { ...this.accountForm.value };
			entryData.debitcredit = entryType === 'debit' ? amount : -amount;

			if (this.editingIndex !== null) {
				this.debits_credits[this.editingIndex] = entryData;
				this.cancelEdit();
			} else {
				this.debits_credits.push(entryData);
				this.accountForm.patchValue({
					account: '',
					description: '',
					debitcredit: 0
				});
				this.updateDepartmentRequiredState(null);
				this.resetjournal = true;
				setTimeout(() => { this.resetjournal = false; }, 100);
			}
		} else {
			this.getFormValidationErrors();
		}
	}

	editLine(line: any, index: number) {
		this.editingIndex = index;
		this.preselectedAccount = line.account;
		this.accountForm.patchValue({
			account: line.account,
			description: line.description,
			entryType: line.debitcredit >= 0 ? 'debit' : 'credit',
			debitcredit: Math.abs(parseFloat(line.debitcredit)),
			department: line.department ?? null
		});
		this.updateDepartmentRequiredState(line.account);
	}

	cancelEdit() {
		this.editingIndex = null;
		this.preselectedAccount = null;
		this.accountForm.patchValue({
			account: '',
			description: '',
			debitcredit: 0
		});
		this.updateDepartmentRequiredState(null);
		this.resetjournal = true;
		setTimeout(() => { this.resetjournal = false; }, 100);
	}

	removeDC(debitcredit: any) {
		const index = this.debits_credits.indexOf(debitcredit);
		if(index < 0) {

		} else {
			this.debits_credits.splice(index,1);
		}
	}

	private handleJournalPostResult(result: any, onSuccess?: () => void) {
		const color = result?.success ? 'success' : 'danger';
		this.globalSearchService.showNotification(result?.message || (result?.success ? 'Journal posted' : 'Post failed'), color, 'bottom', 'center');
		if (result?.success && result?.date_adjusted) {
			const req = result.requested_date || '';
			const eff = result.effective_date || '';
			const detail = req && eff ? ` Requested: ${req} → Posted: ${eff}.` : ' Posting date was moved to today (period was closed).';
			this.globalSearchService.showNotification('Period was closed.' + detail, 'warning', 'bottom', 'center');
		}
		if (result?.success && onSuccess) {
			onSuccess();
		}
	}

	postJournal() {
		if (this.debits_credits.length) {
			if (this.hasExpenseAccount(this.debits_credits, this.expenseSectionId)) {
				const deptVal = this.accountForm.get('department').value;
				const glTagVal = (deptVal && deptVal.tagId !== undefined) ? deptVal.tagId : (deptVal || '');
				if (glTagVal === '' || glTagVal == null) {
					this.globalSearchService.showNotification('Department is required for expense GL accounts.', 'danger', 'bottom', 'center');
					return;
				}
			}
			const dept = this.accountForm.get('department').value;
			const glTag = (dept && dept.tagId !== undefined) ? dept.tagId : (dept || '');
			const transactions = this.debits_credits.map((t: any) => ({
				...t,
				tag: this.getLineTagId(t) || glTag || undefined
			}));
			const payload = { transactions, gl_tag: glTag || '' };
			this.generalLedgerService.postJournalEntry(payload).subscribe((result: any) => {
				this.handleJournalPostResult(result, () => {
					this.editingIndex = null;
					this.preselectedAccount = null;
					this.reversalJournalNumber = null;
					this.setForm();
					this.resetjournal = true;
					setTimeout(() => { this.resetjournal = false; }, 100);
					this.debits_credits = [];
					if (result.transno && this.attachmentFiles.length > 0) {
						this.uploadAttachmentFiles(result.transno);
					}
				});
			});
		}
	}


	exportPdf() {
		this.sending = true;

		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: 'jounral_entry',
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.sending = false;
		});
	}

	exportXls() {
		this.sending = true;

		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: 'jounral_entry',
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}
	announceSortChange(sortState: Sort) {

	}

	displayFn(account: any): string {
		return account.accountname
	}

	back(): void {
		this.location.back()
	}

	onAttachmentSelect(event: { addedFiles: File[] }) {
		this.attachmentFiles.push(...event.addedFiles);
	}

	onAttachmentRemove(file: File) {
		this.attachmentFiles = this.attachmentFiles.filter(f => f !== file);
	}

	private readFileAsDataUrl(file: File): Promise<string | ArrayBuffer> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = e => resolve((e.target as FileReader).result);
			reader.onerror = () => reject(reader.error);
			reader.readAsDataURL(file);
		});
	}

	private uploadAttachmentFiles(transno: number) {
		if (this.attachmentFiles.length === 0) {
			return;
		}
		const uploads = this.attachmentFiles.map((file: File) =>
			from(this.readFileAsDataUrl(file)).pipe(
				switchMap((content: string) => this.generalLedgerService.uploadJournalAttachment(transno, {
					content: content as string,
					name: file.name,
					mime: file.type || 'application/octet-stream'
				}))
			)
		);
		forkJoin(uploads).subscribe({
			next: () => {
				this.globalSearchService.showNotification('Attachments uploaded', 'success', 'bottom', 'center');
				this.attachmentFiles = [];
			},
			error: () => {
				this.globalSearchService.showNotification('Some attachments failed to upload', 'warning', 'bottom', 'center');
				this.attachmentFiles = [];
			}
		});
	}

	onGlUploadChange(event: Event) {
		const input = event.target as HTMLInputElement;
		if (input.files?.length) {
			this.glUploadFiles = Array.from(input.files);
			this.processGlFiles();
		}
	}

	onGlDropzoneDragOver(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		this.glDropzoneActive = true;
	}

	onGlDropzoneDragLeave(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		this.glDropzoneActive = false;
	}

	onGlDropzoneDrop(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		this.glDropzoneActive = false;
		const files = event.dataTransfer?.files;
		if (files?.length) {
			this.glUploadFiles = Array.from(files).filter(f => /\.(csv|xlsx|xls)$/i.test(f.name));
			if (this.glUploadFiles.length) {
				this.processGlFiles();
			}
		}
	}

	private readGlFile(file: File): Promise<ArrayBuffer> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = e => resolve((e.target as FileReader).result as ArrayBuffer);
			reader.onerror = () => reject(reader.error);
			reader.readAsArrayBuffer(file);
		});
	}

	async processGlFiles() {
		this.glUploadedRawData = [];
		this.glUploadedHeaders = [];
		this.glColumnMappings = {};
		for (const file of this.glUploadFiles) {
			try {
				const buf = await this.readGlFile(file);
				const ext = (file.name || '').split('.').pop()?.toLowerCase();
				let rows: Record<string, any>[] = [];
				if (ext === 'xlsx' || ext === 'xls') {
					const workbook = XLSX.read(buf, { type: 'array' });
					const sheet = workbook.Sheets[workbook.SheetNames[0]];
					rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });
				} else if (ext === 'csv') {
					const text = new TextDecoder().decode(buf);
					const lines = text.split(/\r?\n/).filter(l => l.trim());
					if (lines.length >= 2) {
						const header = lines[0].split(',').map(h => h.trim().replace(/^"|"$/g, ''));
						rows = lines.slice(1).map(line => {
							const values = line.split(',').map(v => v.trim().replace(/^"|"$/g, ''));
							const obj: Record<string, any> = {};
							header.forEach((h, i) => { obj[h] = values[i] ?? ''; });
							return obj;
						});
					}
				}
				if (rows.length && Object.keys(rows[0]).length) {
					const headers = Object.keys(rows[0]);
					this.glUploadedHeaders = [...new Set([...this.glUploadedHeaders, ...headers])];
					rows.forEach(r => this.glUploadedRawData.push({ ...r }));
				}
			} catch (e) {
				this.globalSearchService.showNotification('Error parsing file', 'danger', 'bottom', 'right');
			}
		}
		const mappableFields = ['trandate', 'account', 'description', 'debitcredit', 'department'];
		const assigned = new Set<string>();
		this.glUploadedHeaders.forEach(h => {
			const norm = h.trim().toLowerCase();
			if (mappableFields.includes(norm) && !assigned.has(norm)) {
				this.glColumnMappings[h] = norm;
				assigned.add(norm);
			} else {
				this.glColumnMappings[h] = 'ignore';
			}
		});
		this.glUploadReady = this.glUploadedRawData.length > 0;
		this.glUploadPanelExpanded = this.glUploadReady;
	}

	clearGlUpload() {
		this.glUploadFiles = [];
		this.glUploadedRawData = [];
		this.glUploadedHeaders = [];
		this.glColumnMappings = {};
		this.glUploadReady = false;
		this.glUploadPanelExpanded = false;
		this.glDropzoneActive = false;
		this.glError = '';
	}

	private parseGlDate(val: any): string {
		if (val == null || val === '') { return this.now.toISOString().slice(0, 10); }
		if (typeof val === 'number') {
			const epoch = new Date(1899, 11, 30);
			const d = new Date(epoch.getTime() + val * 86400000);
			return isNaN(d.getTime()) ? this.now.toISOString().slice(0, 10) : d.toISOString().slice(0, 10);
		}
		if (val instanceof Date) { return val.toISOString().slice(0, 10); }
		const d = new Date(val);
		return isNaN(d.getTime()) ? this.now.toISOString().slice(0, 10) : d.toISOString().slice(0, 10);
	}

	downloadGlUploadTemplate() {
		const today = this.now.toISOString().slice(0, 10);
		const header = 'trandate,account,description,debitcredit,department';
		const sample1 = today + ',1000,Cash receipt,500.00,';
		const sample2 = today + ',63000,Admin expense,250.00,Operations';
		const sample3 = today + ',4000,Sales revenue,-750.00,';
		const csv = [header, sample1, sample2, sample3].join('\n');
		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
		FileSaver.saveAs(blob, 'gl_journal_upload_template.csv');
	}

	private resolveDepartmentFromUploadValue(val: any): any {
		if (val == null || val === '') { return null; }
		const s = (val + '').trim();
		if (!s) { return null; }
		const tags = this.tags || [];
		const byId = tags.find((t: any) => String(t.tagId || t.tagref || '') === s);
		if (byId) { return byId; }
		const byDesc = tags.find((t: any) => (t.description || '').trim().toLowerCase() === s.toLowerCase());
		return byDesc || null;
	}

	buildGlTransactionsFromUpload(): { trandate: string; account: any; description: string; debitcredit: number; department: any }[] {
		const accountCodes = new Set((this.glaccounts || []).map((a: any) => (a.accountcode || '').toString().trim()));
		const out: { trandate: string; account: any; description: string; debitcredit: number; department: any }[] = [];
		for (const row of this.glUploadedRawData) {
			const mapped: any = {};
			Object.keys(row).forEach(header => {
				const field = this.glColumnMappings[header];
				if (field && field !== 'ignore') { mapped[field] = row[header]; }
			});
			const code = (mapped['account'] || '').toString().trim();
			if (!code || !accountCodes.has(code)) { continue; }
			const desc = (mapped['description'] || '').toString();
			let amt = parseFloat(mapped['debitcredit']);
			if (isNaN(amt)) { amt = 0; }
			const trandateStr = this.parseGlDate(mapped['trandate']);
			const department = this.resolveDepartmentFromUploadValue(mapped['department']);
			const accountObj = (this.glaccounts || []).find((a: any) => (a.accountcode || '').toString().trim() === code);
			if (accountObj) {
				out.push({ trandate: trandateStr, account: accountObj, description: desc, debitcredit: amt, department });
			}
		}
		return out;
	}

	requiredToBalanceUpload(): number {
		const transactions = this.buildGlTransactionsFromUpload();
		return transactions.reduce((acc, t) => acc + parseFloat(String(t.debitcredit)), 0);
	}

	isUploadBatchBalanced(): boolean {
		return Math.abs(this.requiredToBalanceUpload()) < 0.005;
	}

	hasRequiredGlMappings(): boolean {
		const used = new Set<string>();
		Object.keys(this.glColumnMappings).forEach(h => { const v = this.glColumnMappings[h]; if (v && v !== 'ignore') { used.add(v); } });
		if (!used.has('account') || !used.has('debitcredit')) { return false; }
		const transactions = this.buildGlTransactionsFromUpload();
		if (this.hasExpenseAccount(transactions, this.expenseSectionId) && !used.has('department')) {
			return false;
		}
		return true;
	}

	private getFirstExpenseLineMissingDepartment(transactions: any[]): any | null {
		if (!this.expenseSectionId || !transactions?.length) { return null; }
		const sectionId = String(this.expenseSectionId);
		for (const t of transactions) {
			const acc = t?.account;
			if (!acc || String(acc.sectioninaccounts) !== sectionId) { continue; }
			const tagId = this.getLineTagId(t);
			if (tagId === '' || tagId == null) { return t; }
		}
		return null;
	}

	postGlBatch() {
		this.glError = '';
		const transactions = this.buildGlTransactionsFromUpload();
		if (!transactions.length) {
			this.glError = 'No valid lines (map account and debitcredit; account must exist in GL)';
			return;
		}
		if (!this.isUploadBatchBalanced()) {
			this.glError = 'Batch must be in balance before posting (debits = credits)';
			return;
		}
		if (this.hasExpenseAccount(transactions, this.expenseSectionId)) {
			const missing = this.getFirstExpenseLineMissingDepartment(transactions);
			if (missing) {
				this.glError = 'Department is required for expense GL accounts. Map a column to "department" and provide a value (tag name or ID) for each expense line (accounts 6xxx/7xxx).';
				return;
			}
		}
		const glTag = '';
		const transactionsWithTag = transactions.map((t: any) => ({
			...t,
			tag: this.getLineTagId(t) || glTag || undefined
		}));
		this.glPosting = true;
		this.generalLedgerService.postJournalEntry({ transactions: transactionsWithTag, gl_tag: glTag || '' }).subscribe(
			(result: any) => {
				this.glPosting = false;
				this.handleJournalPostResult(result, () => {
					this.clearGlUpload();
					if (result?.transno && this.attachmentFiles.length > 0) {
						this.uploadAttachmentFiles(result.transno);
					}
				});
				if (!result?.success) {
					this.glError = result?.message || 'Post failed';
				}
			},
			err => {
				this.glPosting = false;
				this.glError = err?.error?.message || err?.message || 'Request failed';
			}
		);
	}

}
